{
  "app": {
    "title": "WStudio Reporting Admin",
    "shellTitle": "WSR Product Admin · Consola de Plataforma",
    "loading": "Cargando"
  },
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "remove": "Quitar",
    "create": "Crear",
    "edit": "Editar",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "retry": "Reintentar",
    "search": "Buscar",
    "filter": "Filtrar",
    "clear": "Borrar",
    "reset": "Restablecer",
    "yes": "Sí",
    "no": "No",
    "loading": "Cargando",
    "language": "Idioma",
    "actions": "Acciones",
    "menu": "Menú",
    "unmapped": "Sin asignar",
    "comingSoon": "Próximamente",
    "noProgress": "Sin progreso"
  },
  "help": {
    "ariaLabel": "Ayuda para {{label}}",
    "scope": {
      "platform": "Plataforma",
      "platformDefault": "Por defecto",
      "tenantOverride": "Anulación por inquilino",
      "endpoint": "Endpoint",
      "allJobs": "Todos los trabajos",
      "genesisPacing": "Ritmo de génesis",
      "outboundRate": "Tasa saliente",
      "attendanceOnly": "Solo asistencia"
    }
  },
  "language_switcher": {
    "label": "Idioma",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "home": "Inicio",
    "tenants": "Inquilinos",
    "globalSettings": "Configuración Global",
    "ingestionJobs": "Trabajos de Ingesta",
    "platformSection": "PLATAFORMA",
    "signOut": "Cerrar sesión",
    "signIn": "Iniciar sesión",
    "group": {
      "operations": "Operaciones",
      "configuration": "Configuración"
    },
    "dashboard": "Panel",
    "queue": "Cola",
    "notifications": "Notificaciones",
    "engine": "Motor",
    "globalConfig": "Configuración global"
  },
  "shell": {
    "globalStatus": "Global",
    "globalEnabled": "Activado",
    "globalDisabled": "Desactivado",
    "globalUnknown": "–",
    "globalStatusLabel": "Estado de ingesta global",
    "scope": "Plataforma — todos los inquilinos",
    "notificationsAriaLabel": "Notificaciones",
    "role": {
      "productAdmin": "Administrador de producto"
    }
  },
  "page": {
    "dashboard": { "title": "Panel", "subtitle": "Estado general de la flota." },
    "queue": {
      "title": "Cola",
      "subtitle": "Profundidad de la cola de ingesta, actividad y próximos trabajos."
    },
    "notifications": {
      "title": "Notificaciones",
      "subtitle": "Alertas y notificaciones del sistema."
    },
    "tenants": { "title": "Inquilinos", "subtitle": "Registro y configuración de inquilinos." },
    "engine": { "title": "Motor", "subtitle": "Configuración del motor y la programación." },
    "globalConfig": {
      "title": "Configuración global de WStudio",
      "subtitle": "Rutas y parámetros de endpoints compartidos por todos los inquilinos."
    }
  },
  "jobType": {
    "USER_SYNC": "Sincronización de usuarios",
    "SALES_SYNC": "Sincronización de ventas",
    "ATTENDANCE_SYNC": "Sincronización de asistencia",
    "REPORT_USER_SYNC_SUMMARY": "Resumen de sincronización de usuarios",
    "GHL_FIELD_CHECK": "Verificación de campos GHL",
    "PRODUCT_SYNC": "Sincronización de productos",
    "SALES_RECONCILE": "Reconciliación de ventas"
  },
  "jobTypeHelp": {
    "SALES_RECONCILE": "Recorre el historial de ventas para detectar ediciones posteriores. Una ejecución que no actualiza nada es una ejecución correcta."
  },
  "notifType": {
    "CREDENTIAL_INVALID": {
      "label": "Credencial inválida",
      "title": "Credencial inválida",
      "body": "La credencial de {{integration}} para {{jobType}} es inválida o ha caducado."
    },
    "INGESTION_JOB_FAILURE": {
      "label": "Fallo de trabajo de ingesta",
      "title": "Fallo de trabajo de ingesta",
      "body": "{{jobType}} falló. Último error: {{latestError}}"
    },
    "QUEUE_DEPTH_HIGH": {
      "label": "Profundidad de cola alta",
      "title": "Profundidad de cola alta",
      "body": "Hay {{pending}} trabajos pendientes en la cola."
    },
    "USER_SYNC_NOT_CONFIGURED": {
      "label": "Sincronización de usuarios no configurada",
      "title": "Sincronización de usuarios no configurada",
      "body": "{{jobType}} no está configurado: {{reason}}"
    },
    "USER_SYNC_EVENT_WRITE_FAILED": {
      "label": "Error al escribir evento de sincronización de usuarios",
      "title": "Error al escribir evento de sincronización de usuarios",
      "body": "No se pudo escribir el evento de sincronización de usuarios: {{reason}}"
    },
    "SALES_SYNC_NOT_CONFIGURED": {
      "label": "Sincronización de ventas no configurada",
      "title": "Sincronización de ventas no configurada",
      "body": "{{jobType}} no está configurado: {{reason}}"
    },
    "ATTENDANCE_SYNC_NOT_CONFIGURED": {
      "label": "Sincronización de asistencia no configurada",
      "title": "Sincronización de asistencia no configurada",
      "body": "{{jobType}} no está configurado: {{reason}}"
    },
    "INGESTION_BREAKER_TRIPPED": {
      "label": "Sincronización desactivada — fallos repetidos",
      "title": "Sincronización desactivada — fallos repetidos",
      "body": "{{jobType}} falló en {{failureDays}} días distintos ({{failures}} ejecuciones fallidas) dentro de {{windowHours}} h — más de los {{maxFailures}} tolerados — por lo que se desactivó el servicio. Corrige la causa y vuelve a activar el servicio. Último error: {{latestError}}"
    }
  },
  "jobStatus": {
    "PENDING": "Pendiente",
    "CLAIMED": "Reclamado",
    "RUNNING": "En ejecución",
    "SUCCEEDED": "Correcto",
    "FAILED": "Fallido",
    "SKIPPED": "Omitido"
  },
  "severity": {
    "INFO": "Información",
    "WARN": "Advertencia",
    "ERROR": "Error"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "auth": {
    "redirecting": "Redirigiendo al inicio de sesión…",
    "returning": "Completando inicio de sesión…",
    "noAccessTitle": "No tienes acceso a esta consola",
    "noAccessBody": "Tu cuenta ha iniciado sesión, pero no se le ha concedido acceso a esta consola de administración de producto. Contacta con tu administrador si crees que se trata de un error.",
    "productAdminRequired": "Se requiere acceso de administrador de producto",
    "productAdminRequiredBody": "Has iniciado sesión, pero a tu cuenta no se le ha concedido acceso a esta consola de administración de producto.",
    "signedOutTitle": "Sesión cerrada",
    "signedOutBody": "Tu sesión de administrador de plataforma ha terminado.",
    "signInAgain": "Iniciar sesión de nuevo",
    "errorTitle": "No se pudo completar el inicio de sesión",
    "errorBody": "No se pudo restaurar tu sesión. Intenta iniciar sesión de nuevo.",
    "tryAgain": "Intentar de nuevo"
  },
  "operator": {
    "menuTitle": "Cuenta",
    "platformAdminRequired": "Se requiere administrador de plataforma",
    "platformAdminRequiredBody": "No tienes permiso para ver esto. Se requiere una credencial ROLE_PLATFORM_ADMIN.",
    "role": {
      "SAAS_ADMIN": "Admin de Plataforma",
      "SUPER_ADMIN": "Super Admin"
    }
  },
  "tenants": {
    "title": "Inquilinos",
    "subline": "{{discovered}} descubiertos · {{active}} activos · registro entre inquilinos",
    "searchLabel": "Buscar inquilinos",
    "searchPlaceholder": "Buscar inquilino o slug",
    "tableAriaLabel": "Registro de inquilinos",
    "col": {
      "tenant": "Inquilino",
      "status": "Estado",
      "wstudio": "wStudio",
      "enabled": "Habilitado",
      "enables": "Habilitaciones",
      "services": "Servicios",
      "lastSync": "Última sincronización",
      "progress": "Progreso"
    },
    "tabs": {
      "all": "Todos",
      "active": "Activos",
      "paused": "Pausados",
      "needsAttention": "Requiere atención"
    },
    "enables": {
      "global": "Global",
      "tenant": "Inquilino",
      "on": "Activado",
      "off": "Desactivado",
      "onNotRunning": "Activado, pero sin ejecutarse"
    },
    "detail": {
      "wstudioNotConfigured": "Credenciales WStudio no configuradas para este inquilino.",
      "servicesTitle": "Servicios",
      "effectiveLabel": "Efectivo: {{state}}"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo",
      "suspended": "Suspendido"
    },
    "wstudio": {
      "configured": "Configurado",
      "notConfigured": "No configurado"
    },
    "enabled": {
      "true": "Habilitado",
      "false": "Deshabilitado"
    },
    "lastSync": {
      "never": "—",
      "justNow": "Ahora mismo",
      "minutesAgo": "Hace {{n}} min",
      "hoursAgo": "Hace {{n}} hr",
      "daysAgo": "Hace {{n}} d"
    },
    "backfill": {
      "complete": "✓",
      "neverStarted": "—",
      "through": "hasta {{date}}",
      "phase": {
        "BACKFILL": "Relleno",
        "INCREMENTAL": "Incremental"
      },
      "abbr": {
        "userSync": "US",
        "salesSync": "SS",
        "attendanceSync": "AT",
        "reportSummary": "RS"
      }
    },
    "service": {
      "userSync": "Sincronización de usuarios",
      "salesSync": "Sincronización de ventas",
      "attendanceSync": "Sincronización de asistencia",
      "reportSummary": "Resumen de informe",
      "on": "Activado",
      "off": "Desactivado"
    },
    "emptyTitle": "Sin inquilinos",
    "emptyBody": "No se encontraron inquilinos.",
    "emptySearch": "Ningún inquilino coincide con tu búsqueda.",
    "emptyStatus": "Ningún inquilino de esta página coincide con los filtros seleccionados.",
    "loadError": "No se pudieron cargar los inquilinos.",
    "opsLoadError": "No se pudieron cargar los detalles operativos.",
    "opsNotProvisioned": "Operaciones no aprovisionadas",
    "statusFilter": {
      "label": "Estado",
      "all": "Todos",
      "active": "Activos",
      "suspended": "Suspendidos"
    },
    "actionFilter": {
      "label": "Requiere atención",
      "pageOnly": "Se filtran los inquilinos cargados en esta página."
    },
    "pagination": {
      "previous": "Anterior",
      "next": "Siguiente",
      "pageOf": "Página {{page}} de {{total}}"
    },
    "createButton": "Crear inquilino",
    "create": {
      "title": "Crear inquilino",
      "slugLabel": "Slug",
      "slugHelper": "Letras minúsculas, números, guiones — hasta 63 caracteres.",
      "slugRequired": "El slug es obligatorio.",
      "slugInvalid": "El slug debe ser una etiqueta DNS válida (minúsculas, números, guiones; hasta 63 caracteres).",
      "nameLabel": "Nombre",
      "nameRequired": "El nombre es obligatorio.",
      "nameTooLong": "El nombre debe tener 200 caracteres o menos.",
      "signupModeLabel": "Modo de registro",
      "submitButton": "Crear",
      "submitting": "Creando…",
      "cancelButton": "Cancelar",
      "errorReservedSlug": "Ese slug está reservado. Elige otro.",
      "errorDuplicateSlug": "Ese slug ya está registrado. Elige otro.",
      "errorGeneric": "No se pudo crear el inquilino. Inténtalo de nuevo.",
      "errorOutcomeUnknown": "No pudimos confirmar si se creó el inquilino. La lista de inquilinos se ha actualizado: busca “{{slug}}” en ella antes de volver a intentarlo.",
      "longRunningHint": "Crear un inquilino puede tardar hasta 30 segundos.",
      "success": "Inquilino “{{name}}” creado."
    },
    "signupMode": {
      "PUBLIC": "Público",
      "INVITE_ONLY": "Solo por invitación",
      "ADMIN_CREATED_ONLY": "Solo creado por admin",
      "DISABLED": "Desactivado"
    }
  },
  "queue": {
    "kpi": {
      "pending": "Pendientes",
      "inFlight": "En curso",
      "oldestPending": "Pendiente más antiguo",
      "failedLast24h": "Fallidos (24h)"
    },
    "filters": {
      "tenantLabel": "Inquilino",
      "allTenants": "Todos los inquilinos",
      "pollNote": "En vivo — se actualiza cada ~5s",
      "searchLabel": "Filtrar trabajos",
      "searchPlaceholder": "Inquilino, tipo, estado…"
    },
    "col": {
      "id": "ID",
      "tenant": "Inquilino",
      "jobType": "Tipo de trabajo",
      "kind": "Tipo",
      "status": "Estado",
      "timing": "Tiempo",
      "progress": "Progreso"
    },
    "kind": {
      "GENESIS": "génesis",
      "BACKFILL": "histórico",
      "LEADING_EDGE": "borde actual",
      "INCREMENTAL": "incremental"
    },
    "rowsProcessed": "{{n}} filas",
    "upcoming": {
      "title": "Próximas",
      "overdueTitle": "Atrasadas",
      "overdueBy": "{{duration}} de retraso",
      "colTenant": "Inquilino",
      "colJob": "Trabajo",
      "colNext": "Siguiente",
      "in": "en {{duration}}",
      "dueNow": "pendiente ahora",
      "empty": "Nada programado."
    },
    "card": {
      "running": "Ejecutándose {{duration}}",
      "finishedAgo": "Finalizado hace {{duration}}",
      "scheduledFor": "Programado {{time}}"
    },
    "tableAriaLabel": "Trabajos en cola",
    "empty": "No hay trabajos activos.",
    "emptyFiltered": "Ningún trabajo coincide con los filtros actuales.",
    "loadError": "No se pudo cargar la cola."
  },
  "notifications": {
    "filters": {
      "severityLabel": "Gravedad",
      "allSeverities": "Todas las gravedades",
      "tenantLabel": "Inquilino",
      "allTenants": "Todos los inquilinos",
      "platformOption": "Plataforma (*)",
      "tabsAriaLabel": "Filtrar por estado"
    },
    "tabs": {
      "all": "Todas",
      "open": "Abiertas",
      "acknowledged": "Reconocidas",
      "resolved": "Resueltas"
    },
    "status": {
      "OPEN": "Abierta",
      "ACKNOWLEDGED": "Reconocida",
      "RESOLVED": "Resuelta"
    },
    "meta": {
      "occurrences": "{{n}}× vista",
      "lastSeen": "Vista por última vez {{time}}"
    },
    "remedy": {
      "credentialInvalid": "Vuelve a autenticar la credencial de {{integration}} en saas-auth y luego reactiva {{jobType}}."
    },
    "actions": {
      "acknowledge": "Reconocer",
      "openTenant": "Abrir inquilino"
    },
    "ackError": "No se pudo reconocer esta notificación. Inténtalo de nuevo.",
    "listAriaLabel": "Notificaciones",
    "empty": "No hay notificaciones.",
    "emptyFiltered": "Ninguna notificación coincide con los filtros actuales.",
    "loadError": "No se pudieron cargar las notificaciones.",
    "prevPage": "Página anterior",
    "nextPage": "Página siguiente",
    "pageIndicator": "Página {{page}} de {{total}}"
  },
  "dashboard": {
    "kpiRow": {
      "ariaLabel": "KPI de la flota"
    },
    "kpi": {
      "enabledTenants": "Inquilinos habilitados",
      "enabledTenantsValue": "{{enabled}} de {{total}}"
    },
    "depthTable": {
      "title": "Profundidad por tipo de trabajo",
      "ariaLabel": "Profundidad de cola por tipo de trabajo",
      "col": {
        "jobType": "Tipo de trabajo",
        "pending": "Pendiente",
        "running": "En ejecución",
        "succeeded": "Exitoso",
        "failed": "Fallido"
      },
      "empty": "Aún no hay datos por tipo de trabajo.",
      "loadError": "No se pudo cargar la profundidad de la cola."
    },
    "engineState": {
      "title": "Estado del motor",
      "manageLink": "Gestionar en Motor",
      "loadError": "No se pudo cargar el estado del motor."
    },
    "needsAttention": {
      "title": "Requiere atención",
      "viewAll": "Ver todas las notificaciones",
      "empty": "No hay notificaciones abiertas.",
      "loadError": "No se pudieron cargar las notificaciones."
    }
  },
  "globalConfig": {
    "formAriaLabel": "Formulario de configuración global de WStudio",
    "loadError": "No se pudo cargar la configuración global de WStudio.",
    "saveError": "No se pudo guardar la configuración global de WStudio.",
    "saveSuccess": "Configuración global de WStudio guardada.",
    "save": "Guardar configuración",
    "saveAll": "Guardar todos los ajustes",
    "saving": "Guardando…",
    "tabs": {
      "ariaLabel": "Secciones de configuración global de WStudio",
      "enable": "Activar",
      "attendance": "Asistencia",
      "other": "Adicionales"
    },
    "notes": {
      "silentFailure": "Los valores de los endpoints se envían a WStudio tal como están escritos. Un valor incorrecto suele no devolver datos en lugar de un error — verifíquelo con las pruebas de simulación después de cualquier cambio.",
      "invalidatesVerification": "Guardar un cambio incrementa la generación de configuración y marca como obsoletos los resultados de las pruebas de simulación de todos los inquilinos. Los inquilinos afectados dejan de despachar hasta que se vuelvan a ejecutar sus pruebas de simulación."
    },
    "validation": {
      "path": "Ingrese una ruta que comience con /. Se permite una consulta fija."
    },
    "active": {
      "label": "WStudio habilitado",
      "help": "Controla si la configuración compartida de WStudio está activa."
    },
    "groups": {
      "userList": {
        "title": "Lista de usuarios",
        "help": "Ruta del endpoint y parámetros de solicitud para la lista de usuarios de WStudio."
      },
      "sales": {
        "title": "Ventas",
        "help": "Rutas de endpoints y parámetros para ventas del inquilino y por usuario."
      },
      "report": {
        "title": "Informe",
        "help": "Ruta del endpoint para el informe de asistencia."
      },
      "other": {
        "title": "Ajustes adicionales",
        "help": "Claves globales adicionales devueltas por wsr-api."
      }
    },
    "fields": {
      "unknownHelp": "Valor global proporcionado por wsr-api.",
      "WStudio_user_listWithFilters": {
        "label": "Ruta de la lista de usuarios",
        "help": "Ruta después del dominio del inquilino. Se permite una consulta fija.",
        "detail": "Ruta a la lista de usuarios de WStudio, añadida al dominio de cada inquilino. Proporciona todos los miembros que la plataforma conoce. Puede llevar una cadena de consulta fija; `filter` y `filters` los añade el motor (véase abajo)."
      },
      "WStudio_user_listWithFilters_max": {
        "label": "Máximo de la lista de usuarios",
        "help": "Cantidad máxima de usuarios solicitados por página.",
        "detail": "Miembros obtenidos por petición. El motor pagina hasta agotar la lista, así que esto controla el tamaño de la petición, no cuántos miembros se sincronizan."
      },
      "WStudio_user_listWithFilters_offset": {
        "label": "Desplazamiento de la lista de usuarios",
        "help": "Desplazamiento inicial para solicitudes de la lista de usuarios.",
        "detail": "Posición inicial de la primera página. Déjelo en cero; un valor distinto omite miembros de forma permanente."
      },
      "WStudio_user_listWithFilters_filter": {
        "label": "Término de búsqueda",
        "help": "Filtro opcional enviado con las solicitudes de la lista de usuarios.",
        "detail": "Término de búsqueda de texto libre de WStudio. Normalmente vacío, y aun vacío debe enviarse — el endpoint no devuelve nada si el parámetro falta por completo. Déjelo en blanco salvo que quiera restringir la lista a nombres coincidentes."
      },
      "WStudio_user_listWithFilters_filters": {
        "label": "Criterios de la lista",
        "detail": "Objeto JSON de criterios de WStudio — qué miembros incluye la lista (activos, bloqueados, archivados, empleados, administradores). Distinto de `filter`, pese al nombre casi idéntico. Se guarda como JSON plano; el motor se encarga de la codificación, así que no pegue un valor ya codificado para URL."
      },
      "WStudio_sales_listSales": {
        "label": "Ruta de ventas del inquilino",
        "help": "Ruta después del dominio para las ventas de todo el inquilino.",
        "detail": "Ruta al listado de ventas de todo el estudio — la fuente del almacén de ventas y de todos los informes de ingresos. Su cadena de consulta lleva `includeDeleted` y un `filter=` vacío obligatorio; quitar cualquiera de los dos cambia lo que se recibe, y omitir `filter=` no devuelve nada."
      },
      "WStudio_sales_listForUser": {
        "label": "Ruta de ventas por usuario",
        "help": "Ruta después del dominio para las ventas por usuario.",
        "detail": "Ruta al historial de compras de un miembro concreto. Se usa para enriquecer datos por miembro, no para informes masivos; no es la fuente del almacén de ventas."
      },
      "WStudio_sales_listForUser_max": {
        "label": "Máximo de ventas por usuario",
        "help": "Cantidad máxima de ventas solicitadas por usuario.",
        "detail": "Tamaño de página y posición inicial del historial de un miembro. Aplican las mismas reglas: el offset debe quedarse en cero."
      },
      "WStudio_sales_listForUser_offset": {
        "label": "Desplazamiento de ventas por usuario",
        "help": "Desplazamiento inicial para solicitudes de ventas por usuario.",
        "detail": "Tamaño de página y posición inicial del historial de un miembro. Aplican las mismas reglas: el offset debe quedarse en cero."
      },
      "WStudio_sales_listForUser_forceUpdate": {
        "label": "Forzar actualización",
        "help": "Valor enviado como parámetro para forzar la actualización de ventas por usuario.",
        "detail": "Cuando está activo, el enriquecimiento por miembro se actualiza en cada sincronización, no solo cuando cambió su fecha de vencimiento. Cuesta una petición adicional a WStudio por miembro y ejecución; déjelo desactivado salvo que los datos se vean desactualizados."
      },
      "WStudio_report_checkin": {
        "label": "Ruta del informe de asistencia",
        "help": "Ruta después del dominio para el informe de asistencia.",
        "detail": "Ruta al generador del informe de asistencia. Devuelve un enlace a una hoja de cálculo generada, que el motor descarga y analiza — es una llamada en dos pasos, así que un cambio aquí afecta a ambos."
      },
      "WStudio_product_listByType": {
        "detail": "Ruta al catálogo de productos, consultado una vez por tipo de producto (abajo). El catálogo es lo que permite clasificar una venta como membresía, paquete de clases o entrenamiento personal."
      },
      "WStudio_product_listByType_max": {
        "detail": "Tamaño de página y posición inicial del catálogo de productos. Los catálogos son pequeños; rara vez conviene cambiar los valores por defecto."
      },
      "WStudio_product_listByType_offset": {
        "detail": "Tamaño de página y posición inicial del catálogo de productos. Los catálogos son pequeños; rara vez conviene cambiar los valores por defecto."
      },
      "WStudio_product_types": {
        "detail": "Lista separada por comas de los tipos de producto a obtener, p. ej. `byTime`. El catálogo se consulta una vez por tipo, así que añadir uno añade una petición por inquilino y ejecución. Los tipos no listados nunca se obtienen, y una venta que los referencie no podrá clasificarse."
      },
      "WStudio_membership_gracePeriodDays": {
        "detail": "Cuánto tiempo después de vencer una membresía se sigue considerando activo al miembro, en estado de gracia, antes de darlo por caducado. Ajústelo a cuánto tiempo seguiría llamando miembro a alguien tras un pago fallido."
      },
      "WStudio_membership_shortTermThresholdDays": {
        "detail": "Duración por debajo de la cual una compra cuenta como corta en lugar de membresía. Un pase semanal queda por debajo; una membresía mensual no. Decide si un comprador se etiqueta como miembro o como visitante ocasional."
      },
      "WStudio_membership_renewalDueSoonDays": {
        "detail": "Cuántos días antes del vencimiento se marca a un miembro como próximo a renovar, para que marketing actúe antes de que caduque y no después."
      },
      "WStudio_membership_tenureEstablishedDays": {
        "detail": "Cuánto tiempo desde la primera compra antes de dejar de ser \"nuevo\". Por debajo es nuevo; por encima, establecido."
      },
      "WStudio_membership_tenureLoyalDays": {
        "detail": "Cuánto tiempo desde la primera compra antes de contar como fiel. Debe ser mayor que el umbral de establecido."
      },
      "WStudio_membership_productFamilyByCategory": {
        "detail": "Asigna sus categorías de producto de WStudio a las tres familias que la plataforma entiende — membresía, clase y entrenamiento personal — como pares `categoría:familia` separados por comas. Una entrada mal formada se omite en silencio, así que un error tipográfico hace que esa categoría nunca se asigne; compruebe el resultado tras editar en vez de darlo por hecho."
      },
      "WStudio_membership_valueMidThreshold": {
        "detail": "Umbrales de gasto acumulado que separan a los miembros de valor bajo, medio y alto. Los importes están en la moneda de las propias ventas del miembro, sin convertir — un miembro con compras en dos monedas se deja sin banda en lugar de darle un total engañoso. Deben definirse ambos o no se produce ninguna banda de valor."
      },
      "WStudio_membership_valueHighThreshold": {
        "detail": "Umbrales de gasto acumulado que separan a los miembros de valor bajo, medio y alto. Los importes están en la moneda de las propias ventas del miembro, sin convertir — un miembro con compras en dos monedas se deja sin banda en lugar de darle un total engañoso. Deben definirse ambos o no se produce ninguna banda de valor."
      },
      "WStudio_genesis_syncReadyCoverageDays": {
        "detail": "Cuánto historial de asistencia debe cargarse antes de que un inquilino empiece a sincronizar con GoHighLevel. Es la condición que decide cuándo entra en producción un inquilino recién activado, y hasta cumplirse nada llega al CRM — lo cual es correcto, porque las señales de interacción calculadas con historial parcial serían erróneas. Redúzcalo para entrar antes con menos historial; súbalo para ser más conservador."
      },
      "GhlFieldMappings_CONTACT_PREFIX": {
        "detail": "Prefijo que identifica qué ajustes asignan campos de miembro de WStudio a campos de contacto de GoHighLevel. Es estructural, no un valor a ajustar; cambiarlo deja huérfanas todas las asignaciones existentes."
      }
    }
  },
  "global": {
    "title": "Configuración Global",
    "subtitle": "Controles de toda la plataforma. Los cambios se aplican a todos los inquilinos.",
    "enableSection": "Ingesta global",
    "enableDescription": "Cuando está desactivado, el programador no encola nada para ningún inquilino. El descubrimiento sigue funcionando mientras está desactivado.",
    "enableLabel": "Activar ingesta global",
    "toggleEnabled": "Activado",
    "toggleDisabled": "Desactivado",
    "toggleUnknown": "Desconocido",
    "toggleSuccessOn": "Ingesta global activada.",
    "toggleSuccessOff": "Ingesta global desactivada.",
    "toggleError": "No se pudo actualizar la configuración global. Inténtalo de nuevo.",
    "discoverySection": "Descubrimiento de registro",
    "discoveryDescription": "Ejecuta el barrido de reconciliación saas-auth bajo demanda. Los nuevos inquilinos se materializan inactivos y deshabilitados.",
    "discoveryButton": "Ejecutar descubrimiento ahora",
    "discoveryRunning": "Ejecutando descubrimiento…",
    "discoveryError": "El descubrimiento falló. Inténtalo de nuevo.",
    "discoveryResultTitle": "Descubrimiento completo",
    "discoveryResultSeen": "Vistos",
    "discoveryResultCreated": "Creados",
    "discoveryResultStatusUpdated": "Estado actualizado",
    "discoveryResultLeaversFlagged": "Salientes marcados",
    "statsSection": "Conteos de flota",
    "statTotal": "Total de inquilinos",
    "statActive": "Activos",
    "statActiveNote": "(estado = activo)",
    "statWstudio": "wStudio configurado",
    "loadError": "No se pudieron cargar los conteos de flota."
  },
  "engine": {
    "loadError": "No se pudo cargar la configuración del motor.",
    "formAriaLabel": "Formulario de configuración del motor",
    "restartRequired": "Requiere reinicio",
    "unit": {
      "seconds": "segundos",
      "count": "cantidad"
    },
    "validation": {
      "secondsMin1": "Debe ser un entero ≥ 1.",
      "countMin0": "Debe ser un entero ≥ 0.",
      "countMin1": "Debe ser un entero ≥ 1.",
      "isolationInvalid": "Debe ser uno de los 5 niveles de aislamiento admitidos.",
      "invariant": "heartbeatIntervalSeconds debe ser menor que leaseTtlSeconds, que debe ser menor que maxExecutionTimeSeconds.",
      "invariantHint": "Forma parte de la invariante heartbeat/lease/max-execution."
    },
    "save": {
      "success": "Configuración guardada.",
      "error": "No se pudo guardar la configuración. Inténtalo de nuevo.",
      "changedCount": "{{count}} modificados",
      "noChanges": "Sin cambios",
      "revert": "Revertir",
      "save": "Guardar",
      "saveAll": "Guardar todos los ajustes",
      "saving": "Guardando…"
    },
    "tabs": {
      "ariaLabel": "Secciones de configuración del motor"
    },
    "group": {
      "cadence": "Cadencias",
      "retention": "Retención",
      "tuning": "Ajustes"
    },
    "flags": {
      "title": "Iniciar / detener",
      "globalReadOnly": "Global (solo lectura — ver Inquilinos)",
      "toggleError": "No se pudo actualizar. Inténtalo de nuevo.",
      "engineEnabled": "Motor",
      "engineEnabledDescription": "El ciclo dispatcher/claimer/heartbeat/reaper que ejecuta los trabajos.",
      "discoveryEnabled": "Descubrimiento",
      "discoveryEnabledDescription": "El barrido de reconciliación del registro de inquilinos de saas-auth.",
      "pruneEnabled": "Poda",
      "pruneEnabledDescription": "Limpieza de retención de trabajos terminales y eventos.",
      "orphanSweepEnabled": "Barrido de huérfanos",
      "orphanSweepEnabledDescription": "Elimina archivos temporales sobrantes del proceso de asistencia, que descarga una hoja de cálculo generada en disco y normalmente la borra de inmediato. Este barrido es el respaldo para un proceso interrumpido durante la descarga. No afecta a los trabajos ni a los datos."
    },
    "fields": {
      "engineEnabled": {
        "detail": "Interruptor principal del ciclo de ingesta: despachador, reclamador, latido y recuperador. Apagarlo es una pausa ordenada — los trabajos en curso terminan, no se encola ni se reclama nada nuevo y no se pierden datos. Úselo para detener la plataforma durante el mantenimiento en lugar de desactivar inquilinos uno por uno."
      },
      "discoveryEnabled": {
        "detail": "Barrido que concilia la lista de inquilinos con saas-auth, para que los inquilinos añadidos o eliminados allí aparezcan aquí sin registro manual. Apagarlo congela la lista; los inquilinos existentes siguen sincronizando con normalidad."
      },
      "pruneEnabled": {
        "detail": "Mantenimiento que elimina los trabajos finalizados y los eventos de auditoría más antiguos que las ventanas de retención. Apagarlo conserva el historial indefinidamente y las tablas crecen sin límite."
      },
      "orphanSweepEnabled": {
        "detail": "Elimina archivos temporales sobrantes del proceso de asistencia, que descarga una hoja de cálculo generada en disco y normalmente la borra de inmediato. Este barrido es el respaldo para un proceso interrumpido durante la descarga. No afecta a los trabajos ni a los datos."
      },
      "dispatcherIntervalSeconds": {
        "detail": "Con qué frecuencia el motor comprueba qué trabajos corresponden y los encola. Es un límite inferior para todo lo demás: un trabajo programado cada minuto solo arranca cuando el despachador se ejecuta. Con 900s (15m), una ventana de asistencia avanza como máximo cuatro veces por hora; con 60s, hasta una vez por minuto. Bajarlo es barato — la comprobación es una sola consulta."
      },
      "claimerIntervalSeconds": {
        "detail": "Con qué frecuencia los trabajadores buscan trabajo encolado. Es un sondeo de filas ya creadas, así que controla la latencia de recogida, no cuánto trabajo existe. Rara vez conviene cambiar los 5s por defecto."
      },
      "heartbeatIntervalSeconds": {
        "detail": "Con qué frecuencia un trabajo en curso indica que sigue vivo, extendiendo su arrendamiento. Debe quedar holgadamente por debajo del TTL del arrendamiento, o un trabajo largo y sano — un recorrido de génesis o una ventana grande de asistencia — será reclamado como si hubiera muerto."
      },
      "reaperIntervalSeconds": {
        "detail": "Con qué frecuencia el motor busca trabajos cuyo arrendamiento expiró o que superaron el tiempo máximo de ejecución, y los devuelve a la cola. Es lo que recupera el trabajo tras un fallo o un despliegue que reinició la aplicación a mitad de ejecución."
      },
      "terminalCleanupIntervalSeconds": {
        "detail": "Con qué frecuencia se eliminan los trabajos finalizados que superan la retención. Puro mantenimiento; nunca toca trabajo en curso ni pendiente."
      },
      "discoveryIntervalSeconds": {
        "detail": "Con qué frecuencia se concilia la lista de inquilinos con saas-auth. Cada hora es suficiente — un inquilino nuevo aparece en un intervalo."
      },
      "pruneIntervalSeconds": {
        "detail": "Con qué frecuencia se ejecuta la limpieza por retención. Poco frecuente está bien: es un borrado masivo, y ejecutarlo rara vez sale mejor que hacerlo constantemente."
      },
      "orphanSweepIntervalSeconds": {
        "detail": "Con qué frecuencia se buscan archivos temporales sobrantes. Solo se eliminan los más antiguos que la edad de barrido, así que puede ejecutarse con poca frecuencia sin riesgo."
      },
      "terminalRetentionSeconds": {
        "detail": "Cuánto tiempo se conservan los trabajos finalizados antes de purgarlos. Es su historial: con 14 días puede investigar un fallo de la semana pasada, pero no del mes pasado. Aumentarlo cuesta tamaño de tabla, no rendimiento."
      },
      "eventRetentionSeconds": {
        "detail": "Cuánto tiempo se conservan los eventos de auditoría y actividad. Más que la retención de trabajos por diseño — los eventos registran qué cambió y quién lo cambió, algo útil mucho después de que el trabajo que lo produjo deje de importar."
      },
      "orphanSweepAgeSeconds": {
        "detail": "Qué antigüedad debe tener un archivo temporal antes de eliminarlo. Debe superar la descarga de asistencia más lenta realista, o el barrido podría borrar un archivo aún en uso. Las 6 horas por defecto son deliberadamente generosas."
      },
      "defaultFrequencySeconds": {
        "detail": "Intervalo de repetición para los tipos de trabajo que no definen su propia programación. Los tipos con programación real — sincronizaciones diarias, barrido de reconciliación, esperas de relleno — lo ignoran por completo."
      },
      "leaseTtlSeconds": {
        "detail": "Cuánto tiempo se considera vivo un trabajo reclamado sin latido antes de que el recuperador pueda reclamarlo. Póngalo varias veces el intervalo de latido; si es muy ajustado, trabajos largos y sanos se reclaman a media ejecución y repiten trabajo."
      },
      "maxExecutionTimeSeconds": {
        "detail": "Techo absoluto para una ejecución, con independencia de los latidos. Un trabajo que lo supera se considera colgado y se termina en lugar de reintentarse indefinidamente. Debe superar su ejecución legítima más lenta — una ventana grande de asistencia o un recorrido largo de génesis."
      },
      "retryBackoffBaseSeconds": {
        "detail": "Espera inicial antes de reintentar un trabajo fallido. Cada fallo posterior espera más, hasta el tope siguiente, para que una caída transitoria no se convierta en un bucle de reintentos contra un sistema ya sobrecargado."
      },
      "retryBackoffCapSeconds": {
        "detail": "Espera máxima a la que puede crecer el reintento. Acota cuánto pueden envejecer los datos durante una caída sostenida: con 1 hora, un inquilino reintenta al menos cada hora por larga que sea la indisponibilidad."
      },
      "ratePerTenantPeriodSeconds": {
        "detail": "Ventana temporal sobre la que se cuentan los permisos de petición por inquilino. Junto con los permisos siguientes forma la regla \"como máximo N peticiones por inquilino y periodo\" — el control principal sobre cuánta carga recibe cada estudio de WStudio."
      },
      "rateGlobalPeriodSeconds": {
        "detail": "Ventana del techo de peticiones de toda la plataforma. Solo aplica cuando los permisos globales son mayores que cero. Requiere reinicio."
      },
      "maxAttempts": {
        "detail": "Cuántas veces se reintenta un trabajo que falla antes de marcarlo como fallido permanente. Distinto de los rescates: los intentos cuentan que el trabajo falle, los rescates cuentan que el trabajador muera."
      },
      "maxRescues": {
        "detail": "Cuántas veces puede recuperarse un trabajo tras la muerte de su trabajador — un fallo o un despliegue — antes de considerarlo tóxico y fallarlo. Se cuenta aparte de los intentos para no imputar a un trabajo fallos que no causó."
      },
      "batchClaimSize": {
        "detail": "Cuántos trabajos encolados reclama un trabajador en una sola consulta. Lotes grandes reducen la sobrecarga cuando la cola es profunda; lotes pequeños reparten mejor. Rara vez conviene cambiarlo."
      },
      "perTenantInFlightCap": {
        "detail": "Número máximo de trabajos que pueden ejecutarse a la vez para un mismo inquilino. Con 1, sus sincronizaciones de ventas, asistencia, productos y usuarios van estrictamente en serie — la razón principal de que cargar el historial parezca lento. Subirlo a 3 permite que el relleno de asistencia avance junto a otro trabajo, sin que un inquilino acapare todo el grupo de trabajadores."
      },
      "maxConcurrent": {
        "detail": "Número total de trabajos en ejecución simultánea entre todos los inquilinos. Es el techo de la plataforma; el límite por inquilino lo reparte con equidad. Con 5 concurrentes y un límite de 3 por inquilino, un solo inquilino ocupado nunca ocupa más de tres de las cinco plazas. Requiere reinicio."
      },
      "failureAlertThreshold": {
        "detail": "Cuántos fallos consecutivos del mismo trabajo y el mismo inquilino hacen falta para generar una notificación. Con 3, los dos primeros fallos son silenciosos. Póngalo en 1 para enterarse de cada fallo — útil al incorporar inquilinos o diagnosticar una integración nueva."
      },
      "failureBreakerMaxFailures": {
        "detail": "Cuántos días distintos (hora del estudio) puede fallar un trabajo para un inquilino — contados desde su última ejecución correcta o reactivación, y solo dentro de la ventana del disyuntor — antes de que se desactive el servicio de ese inquilino. 0 lo desactiva el primer día con fallo. Distinto del umbral de alerta de fallos de arriba, que solo genera una notificación."
      },
      "failureBreakerWindowHours": {
        "detail": "Solo cuentan para el disyuntor los fallos dentro de estas últimas horas. 0 desactiva el disyuntor: los fallos siguen generando alertas, pero el servicio nunca se desactiva."
      },
      "ratePerTenantPermits": {
        "detail": "Cuántas peticiones a WStudio se permiten por inquilino en cada periodo. Es el dial de cortesía — limita cuánta carga recibe un estudio concreto, con independencia de cuántos trabajos se ejecuten. Bájelo si el sistema remoto se queja; súbalo con prudencia."
      },
      "rateGlobalPermits": {
        "detail": "Techo para toda la plataforma sumando inquilinos. Cero lo desactiva, dejando solo el límite por inquilino — la configuración habitual, ya que los estudios son sistemas separados y el tráfico de un inquilino no carga al de otro. Requiere reinicio."
      },
      "skipLockedClaim": {
        "detail": "Permite a los trabajadores saltar filas ya bloqueadas por otro trabajador en vez de esperarlas. Manténgalo activo: desactivado, los trabajadores hacen cola por las mismas filas y el rendimiento cae mucho. Desactívelo solo si la base de datos no soporta la función."
      },
      "isolation": {
        "detail": "Nivel de aislamiento de transacción al reclamar trabajos. `READ_COMMITTED` es la opción correcta para esta cola y no debería cambiarse sin un motivo concreto — niveles más estrictos añaden contención sin beneficio aquí. Requiere reinicio."
      }
    },
    "emphasis": {
      "dispatcherInterval": "Es un límite inferior para todo lo demás: un trabajo programado cada minuto solo arranca cuando el despachador se ejecuta.",
      "inFlightCap": "Con 1, sus sincronizaciones de ventas, asistencia, productos y usuarios van estrictamente en serie — la razón principal de que cargar el historial parezca lento.",
      "failureBreakerMaxFailures": "Días distintos (hora del estudio) con una ejecución fallida, desde la última ejecución correcta o la reactivación, antes de que se desactive el servicio. 0 = desactivar el primer día con fallo.",
      "failureBreakerWindowHours": "Solo cuentan los fallos dentro de esta cantidad de horas. 0 = disyuntor desactivado (solo alertas)."
    },
    "knob": {
      "dispatcherIntervalSeconds": "Intervalo del dispatcher",
      "claimerIntervalSeconds": "Intervalo del claimer",
      "heartbeatIntervalSeconds": "Intervalo del heartbeat",
      "reaperIntervalSeconds": "Intervalo del reaper",
      "terminalCleanupIntervalSeconds": "Intervalo de limpieza terminal",
      "discoveryIntervalSeconds": "Intervalo de descubrimiento",
      "pruneIntervalSeconds": "Intervalo de poda",
      "orphanSweepIntervalSeconds": "Intervalo de barrido de huérfanos",
      "terminalRetentionSeconds": "Retención terminal",
      "eventRetentionSeconds": "Retención de eventos",
      "orphanSweepAgeSeconds": "Antigüedad de barrido de huérfanos",
      "defaultFrequencySeconds": "Frecuencia predeterminada",
      "leaseTtlSeconds": "TTL de arrendamiento",
      "maxExecutionTimeSeconds": "Tiempo máximo de ejecución",
      "retryBackoffBaseSeconds": "Base de reintento con retroceso",
      "retryBackoffCapSeconds": "Tope de reintento con retroceso",
      "ratePerTenantPeriodSeconds": "Período de límite de tasa (por inquilino)",
      "rateGlobalPeriodSeconds": "Período de límite de tasa (global)",
      "maxAttempts": "Máximo de intentos",
      "maxRescues": "Máximo de rescates",
      "batchClaimSize": "Tamaño de lote de reclamo",
      "perTenantInFlightCap": "Tope en curso (por inquilino)",
      "maxConcurrent": "Máximo concurrente",
      "failureAlertThreshold": "Umbral de alerta de fallos",
      "failureBreakerMaxFailures": "Días de fallo tolerados",
      "failureBreakerWindowHours": "Ventana del disyuntor (horas)",
      "ratePerTenantPermits": "Permisos de límite de tasa (por inquilino)",
      "rateGlobalPermits": "Permisos de límite de tasa (global)",
      "skipLockedClaim": "Omitir bloqueados al reclamar",
      "isolation": "Aislamiento de transacción"
    }
  },
  "jobs": {
    "tableAriaLabel": "Trabajos de ingesta",
    "empty": "No hay trabajos registrados.",
    "prevPage": "Página anterior",
    "nextPage": "Página siguiente",
    "pageIndicator": "Página {{page}} de {{total}}",
    "col": {
      "job": "Trabajo",
      "status": "Estado",
      "type": "Tipo",
      "tenant": "Inquilino",
      "started": "Iniciado",
      "duration": "Duración",
      "records": "Registros",
      "actions": "Acciones"
    },
    "status": {
      "queued": "En cola",
      "running": "Ejecutándose",
      "success": "Éxito",
      "failed": "Fallido",
      "skipped": "Omitido"
    },
    "chip": {
      "statusAriaLabel": "Estado: {{label}}"
    },
    "actions": {
      "cancel": "Cancelar",
      "cancelNotSupported": "Cancelación aún no disponible",
      "cancelAriaLabel": "Cancelar trabajo {{id}}"
    }
  },
  "ingestionJobs": {
    "title": "Trabajos de Ingesta",
    "filtersAriaLabel": "Filtros de trabajo",
    "filterStatus": "Estado",
    "filterType": "Tipo",
    "filterTenant": "Inquilino",
    "allStatuses": "Todos los estados",
    "allTypes": "Todos los tipos",
    "allTenants": "Todos los inquilinos",
    "typeUserSync": "Sincronización de usuarios",
    "typeSalesSync": "Sincronización de ventas",
    "typeAttendanceSync": "Sincronización de asistencia",
    "typeReportSummary": "Resumen de sincronización",
    "totalCount": "{{total}} trabajos",
    "tableAriaLabel": "Trabajos de ingesta entre inquilinos",
    "loadError": "No se pudieron cargar los trabajos de ingesta."
  },
  "tenant": {
    "tab": {
      "overview": "Resumen",
      "members": "Personal",
      "invitations": "Invitaciones",
      "ingestion": "Ingesta",
      "history": "Historial de sincronización",
      "wstudio": "WStudio Config",
      "contacts": "Asignación de contactos",
      "advanced": "Avanzado",
      "settings": "Configuración"
    }
  },
  "problems": {
    "jobFailures": "{{job}} — {{code}}, {{count}}× en 24 h, hace {{ago}}",
    "ghlWriteFailures": "{{count}} contactos no se pudieron escribir en GoHighLevel en la última ejecución.",
    "noData": "{{job}} — no hubo registros en la última ejecución; conviene revisarlo.",
    "verification": "{{job}} — la verificación no pasa; vuelva a ejecutar la prueba",
    "generic": "{{job}} — requiere atención"
  },
  "runNow": {
    "button": "Ejecutar ahora",
    "enqueued": "{{service}} se puso en cola. Aparecerá en la Cola en unos segundos.",
    "alreadyRunning": "{{service}} ya está en ejecución.",
    "blockedTitle": "{{service}} no se puede ejecutar:",
    "error": "No se pudo iniciar {{service}}.",
    "queueLink": "Abrir la Cola",
    "blocked": {
      "GLOBAL_DISABLED": "La ingesta está deshabilitada globalmente.",
      "TENANT_DISABLED": "Este inquilino está deshabilitado.",
      "SERVICE_DISABLED": "Este servicio está desactivado.",
      "NOT_VERIFIED": "Ejecute primero las pruebas de simulación.",
      "NOT_SYNC_READY": "Esperando a que termine de cargar el historial.",
      "NOT_CONFIGURED": "Las credenciales de WStudio no están configuradas para este inquilino.",
      "unknown": "Este servicio no se puede ejecutar en este momento."
    }
  },
  "tenantDetail": {
    "loadError": "No se pudo cargar el inquilino. Inténtalo de nuevo.",
    "notFound": "Inquilino no encontrado",
    "notFoundBody": "El inquilino '{{slug}}' no pudo ser encontrado.",
    "backToRoster": "Volver a inquilinos",
    "opsLoadError": "No se pudo cargar la configuración operativa.",
    "tabs": {
      "ariaLabel": "Secciones de detalle del inquilino"
    },
    "overview": {
      "disabledTitle": "Deshabilitado",
      "disabledGlobal": "La ingesta está desactivada en toda la plataforma",
      "disabledTenant": "Este inquilino está desactivado",
      "disabledHint": "Cámbielos en la pestaña Ingesta.",
      "problemsTitle": "Problemas",
      "problemsNone": "Sin problemas: aquí aparecen los fallos y la verificación obsoleta.",
      "problemStale": "{{job}} — la verificación está obsoleta, vuelva a ejecutar la prueba",
      "problemFailed": "{{job}} — la verificación falló"
    },
    "settings": {
      "title": "Configuración de WStudio del tenant",
      "formAriaLabel": "Formulario de configuración de WStudio del tenant",
      "loadError": "No se pudo cargar la configuración de WStudio.",
      "save": "Guardar configuración de WStudio",
      "saving": "Guardando…",
      "saveSuccess": "Configuración de WStudio guardada.",
      "saveSuccessReverify": "La configuración cambió: vuelva a ejecutar las cuatro pruebas de simulación para verificar este inquilino.",
      "saveError": "No se pudo guardar la configuración de WStudio.",
      "domain": { "label": "Dominio", "help": "URL base requerida del tenant de WStudio." },
      "token": {
        "label": "Token de API de WStudio",
        "set": "Configurado · {{suffix}}",
        "notSet": "No configurado",
        "replace": "Reemplazar",
        "replacement": "Token nuevo",
        "help": "Solo escritura. En blanco conserva el token guardado."
      },
      "studioId": {
        "label": "ID del estudio",
        "help": "Valor del encabezado Studioid de WStudio."
      },
      "reportUserId": {
        "label": "ID de usuario de reportes",
        "help": "ID usado para generar reportes de asistencia."
      },
      "contacts": {
        "title": "Mapeos de campos de contacto",
        "help": "Mapee claves contact.* a IDs de campo de GHL.",
        "key": "Clave de contacto",
        "value": "ID de campo de GHL",
        "add": "Agregar mapeo",
        "remove": "Eliminar",
        "catalogTitle": "Asignaciones estándar",
        "catalogHelp": "Se gestionan globalmente y se aplican a todos los inquilinos. El ID de campo de GoHighLevel se resuelve automáticamente.",
        "addedTitle": "Asignaciones adicionales",
        "addedHelp": "Elija un atributo de usuario de WStudio. El ID de campo de GoHighLevel se detecta al guardar.",
        "col": {
          "key": "Clave de contacto",
          "attribute": "Atributo de WStudio",
          "fieldId": "ID de campo de GoHighLevel",
          "status": "Estado"
        },
        "attributeLabel": "Atributo de usuario de WStudio",
        "fieldKeyLabel": "Clave de campo de GoHighLevel",
        "status": {
          "resolved": "Resuelto",
          "legacy": "Resuelto por ID",
          "notFound": "No se encontró en GoHighLevel",
          "unknownAttribute": "Atributo desconocido",
          "retired": "Retirado",
          "retiredHelp": "Las asignaciones a campos principales ya no se admiten. Esta asignación se ignora: elimínela."
        },
        "unresolvedWarning": "No se pudieron resolver una o más asignaciones obligatorias. Cree el campo personalizado correspondiente en GoHighLevel y vuelva a ejecutar las pruebas de simulación.",
        "attributesUnavailable": "La lista de atributos de WStudio no está disponible, por lo que no se pueden añadir asignaciones ahora."
      },
      "advanced": {
        "title": "Avanzado — sobrescribir configuración global",
        "override": "Sobrescribir",
        "overriding": "Sobrescribiendo",
        "default": "Predeterminado",
        "revert": "Volver al predeterminado",
        "derived": "Valor derivado",
        "defaultValue": "predeterminado: {{value}}",
        "fullUrl": "URL completa sobrescrita",
        "urlHelp": "Una URL sobrescrita reemplaza por completo el dominio y la ruta global."
      },
      "validation": {
        "domain": "El dominio es obligatorio.",
        "contact": "Ingrese una clave contact.<campo> y un ID para cada mapeo.",
        "duplicateContact": "Las claves de contacto deben ser únicas.",
        "attributeRequired": "Elija un atributo de usuario de WStudio para cada asignación.",
        "fullUrl": "Ingrese una URL http(s) completa.",
        "nonNegativeInt": "Ingrese un número entero de 0 o más.",
        "nonNegativeNumber": "Ingrese un importe de 0 o más.",
        "valueThresholdOrder": "El umbral de valor medio debe ser menor o igual que el de valor alto.",
        "tenureOrder": "El umbral de antigüedad establecida debe ser menor o igual que el de antigüedad leal."
      },
      "membership": {
        "title": "Membresía y clasificación",
        "help": "Estos ajustes se leen en conjunto para clasificar a los miembros con fines de marketing.",
        "valueHelp": "Ambos umbrales deben estar definidos para que se ejecute la clasificación por valor. Dejarlos en blanco es una opción válida: no se produce ninguna clasificación por valor.",
        "valuePartial": "Solo hay un umbral definido, por lo que la clasificación por valor permanece desactivada."
      },
      "fields": {
        "WStudio_user_listWithFilters": "URL de lista de usuarios",
        "WStudio_user_listWithFilters_max": "Máximo de usuarios",
        "WStudio_user_listWithFilters_offset": "Desplazamiento de usuarios",
        "WStudio_user_listWithFilters_filter": "Filtro de usuarios",
        "WStudio_sales_listSales": "URL de ventas del tenant",
        "WStudio_sales_listForUser": "URL de ventas por usuario",
        "WStudio_sales_listForUser_max": "Máximo de ventas por usuario",
        "WStudio_sales_listForUser_offset": "Desplazamiento de ventas por usuario",
        "WStudio_sales_listForUser_forceUpdate": "Forzar actualización",
        "WStudio_report_checkin": "URL del reporte de asistencia",
        "WStudio_product_listByType": "URL del catálogo de productos",
        "WStudio_product_listByType_max": "Máximo del catálogo de productos",
        "WStudio_product_listByType_offset": "Desplazamiento del catálogo de productos",
        "WStudio_product_types": "Tipos de producto a sincronizar",
        "WStudio_membership_gracePeriodDays": "Período de gracia (días)",
        "WStudio_membership_shortTermThresholdDays": "Umbral de corto plazo (días)",
        "WStudio_membership_renewalDueSoonDays": "Renovación próxima (días)",
        "WStudio_membership_tenureEstablishedDays": "Antigüedad establecida (días)",
        "WStudio_membership_tenureLoyalDays": "Antigüedad leal (días)",
        "WStudio_membership_valueMidThreshold": "Umbral de valor medio",
        "WStudio_membership_valueHighThreshold": "Umbral de valor alto",
        "WStudio_genesis_syncReadyCoverageDays": "Cobertura de asistencia requerida antes de sincronizar (días)"
      }
    },
    "verification": {
      "allVerified": "WStudio verificado",
      "notVerified": "WStudio no configurado / no verificado",
      "prompt": "Ejecute las cuatro pruebas de simulación para verificar este inquilino.",
      "verified": "Verificado",
      "failed": "Falló",
      "notRun": "Sin ejecutar",
      "stale": "Obsoleto — se debe repetir"
    },
    "header": {
      "dispatchState": "Estado de despacho",
      "dispatchRunning": "Las sincronizaciones están en ejecución",
      "dispatchUnknown": "Estado global desconocido",
      "blockedGlobal": "Bloqueado — global desactivado",
      "blockedTenant": "Bloqueado — inquilino desactivado",
      "blockedServices": "Bloqueado — sin servicios habilitados",
      "lastSync": "Última sincronización",
      "statusLabel": "Estado del inquilino: {{status}}",
      "leftRosterChip": "Salió del registro",
      "leftRosterAriaLabel": "Este inquilino ha salido del registro saas-auth",
      "leftRosterBody": "Este inquilino ha salido del registro saas-auth. Ha sido marcado pero no eliminado — los datos existentes se conservan."
    },
    "actions": {
      "title": "Acciones del inquilino",
      "tenantEnabled": "Inquilino habilitado",
      "enabledLabel": "Inquilino habilitado",
      "disabledLabel": "Inquilino deshabilitado",
      "tenantEnabledHelper": "Cuando está desactivado, este inquilino se omite completamente — sin sincronizaciones ni informes.",
      "enableSuccess": "Inquilino habilitado.",
      "disableSuccess": "Inquilino deshabilitado.",
      "enableError": "No se pudo actualizar el estado del inquilino. Inténtalo de nuevo.",
      "confirmEnableTitle": "¿Habilitar inquilino?",
      "confirmEnableBody": "Esto permitirá que las sincronizaciones se ejecuten para este inquilino cuando los interruptores global y de servicio también estén activados.",
      "confirmDisableTitle": "¿Deshabilitar inquilino?",
      "confirmDisableBody": "Esto impedirá todas las sincronizaciones e informes para este inquilino.",
      "statusActionsTitle": "Estado del inquilino",
      "markActive": "Marcar como activo",
      "suspendTenant": "Suspender inquilino",
      "statusWriteUnavailable": "La gestión de estado aún no está disponible en esta consola. Usa saas-admin para cambiar el estado del inquilino.",
      "statusWriteHint": "El estado se gestiona a través de saas-admin."
    },
    "confirm": {
      "confirmButton": "Confirmar",
      "cancelButton": "Cancelar"
    },
    "gate": {
      "title": "Interruptores de habilitación",
      "gateRule": "Regla de puerta:",
      "explainer": "Un trabajo se ejecuta solo cuando global, inquilino y servicio están TODOS activados.",
      "globalLevel": "Global",
      "globalReadOnly": "Solo lectura aquí.",
      "globalLink": "Gestionar en Configuración Global",
      "tenantLevel": "Inquilino",
      "tenantHint": "Gestionado en Acciones del inquilino arriba.",
      "serviceLevel": "Servicios",
      "gateOn": "Activado",
      "gateOff": "Desactivado",
      "gateUnknown": "Desconocido"
    },
    "services": {
      "enableSuccess": "{{service}} habilitado.",
      "disableSuccess": "{{service}} deshabilitado.",
      "enableError": "No se pudo actualizar {{service}}."
    },
    "config": {
      "title": "Configuración",
      "formAriaLabel": "Formulario de configuración del inquilino",
      "saveButton": "Guardar configuración",
      "saving": "Guardando…",
      "resetButton": "Restablecer",
      "unsavedChanges": "Cambios sin guardar",
      "saveSuccess": "Configuración guardada.",
      "saveError": "No se pudo guardar la configuración. Inténtalo de nuevo.",
      "validationError": "Validación fallida. Comprueba tu entrada e inténtalo de nuevo.",
      "fieldRequired": "Este campo es obligatorio.",
      "freqMin1": "La frecuencia debe ser un entero ≥ 1.",
      "invalidTime": "Debe estar en formato HH:mm (p.ej. 00:30).",
      "invalidSendTimes": "Cada hora debe estar en formato HH:mm, separada por comas.",
      "invalidDate": "Debe ser una fecha válida (AAAA-MM-DD).",
      "cooldownMin1": "El enfriamiento debe ser un entero ≥ 1.",
      "userSyncFrequency": "Frecuencia de sincronización de usuarios (horas)",
      "userSyncFrequencyHelper": "Con qué frecuencia se ejecuta la sincronización WStudio→GHL. Mínimo 1.",
      "dailySyncTime": "Hora de sincronización diaria (HH:mm)",
      "dailySyncTimeHelper": "Cuándo se ejecuta la extracción diaria del día anterior.",
      "userSyncSendTimes": "Horarios de envío del resumen",
      "userSyncSendTimesPlaceholder": "p.ej. 09:00,17:00",
      "userSyncSendTimesHelper": "Horarios HH:mm separados por comas para el correo de resumen. Vacío = sin informe programado.",
      "backfillStartDate": "Fecha de inicio del relleno",
      "backfillStartDateHelper": "Fecha de inicio para el relleno de ventas/asistencia (AAAA-MM-DD).",
      "backfillCooldown": "Enfriamiento del relleno (minutos)",
      "backfillCooldownHelper": "Descanso entre bloques semanales de relleno en minutos."
    },
    "dryRun": {
      "title": "Pruebas de simulación",
      "subtitle": "Valida antes de habilitar — sin escritura de datos.",
      "salesTitle": "Simulación de ventas",
      "attendanceTitle": "Simulación de asistencia",
      "userTitle": "Simulación de usuarios",
      "ghlFieldsTitle": "Verificación de campos de GHL",
      "from": "Desde",
      "to": "Hasta",
      "run": "Ejecutar prueba",
      "running": "Ejecutando…",
      "runError": "La solicitud de simulación falló. Inténtalo de nuevo.",
      "success": "Éxito",
      "failure": "Fallido",
      "notConfigured": "No configurado",
      "warnings": "Advertencias",
      "sampleData": "Datos de muestra",
      "sampleRows": "{{n}} filas",
      "errorLabel": "Error:",
      "unknownError": "Error desconocido",
      "writeNothing": "Solo simulación — no se escriben datos, no se mueven marcas de agua.",
      "table": {
        "title": "Registros de muestra",
        "count": "Mostrando {{n}} de {{total}} obtenidos",
        "empty": "No hay registros en esta ventana.",
        "mapped": "asignado"
      },
      "match": {
        "create": "Crear",
        "update": "Actualizar",
        "noChange": "Sin cambios"
      },
      "counts": {
        "user": "{{n}} usuarios obtenidos",
        "sales": "{{n}} registros obtenidos (una página)",
        "attendance": "{{n}} filas procesadas",
        "generic": "{{n}} registros obtenidos",
        "salesHelp": "Una página según el máximo configurado: no es el total de ventas del inquilino ni necesariamente las ventas más recientes."
      },
      "plan": {
        "title": "Plan de sincronización",
        "population": "{{wstudioUsers}} usuarios de WStudio · {{ghlContacts}} contactos de GoHighLevel",
        "create": "{{n}} se crearían",
        "update": "{{n}} se actualizarían",
        "noChange": "{{n}} ya están al día",
        "unmatched": "{{n}} contactos sin coincidencia en WStudio",
        "unmatchedHelp": "No se modifican: la sincronización nunca desactiva ni elimina contactos.",
        "lastPurchaseFootnote": "No se comprueban los cambios de última compra, por lo que el número de actualizaciones es un mínimo.",
        "cappedWarning": "La extracción de usuarios de WStudio se limitó: estos números cubren solo una parte de la población.",
        "allCreateWarning": "GoHighLevel tiene {{ghlContacts}} contactos, pero los {{wstudioUsers}} usuarios de WStudio se crearían en lugar de coincidir. La asignación contact.wstudio_id apunta al campo equivocado de GoHighLevel y una sincronización real duplicaría todos los contactos. Verifique la asignación antes de habilitar la sincronización."
      },
      "requestUrl": {
        "label": "Solicitud a WStudio"
      },
      "attendance": {
        "title": "Análisis del informe",
        "rowsInSheet": "{{n}} filas en el informe",
        "parsed": "{{n}} procesadas",
        "openGym": "{{n}} filas de gimnasio libre omitidas",
        "incomplete": "{{n}} filas incompletas omitidas",
        "emptyReport": "El informe se generó correctamente pero no contenía filas para esta ventana.",
        "incompleteWarning": "{{n}} de {{total}} filas llegaron sin fecha, hora o miembro. Esto suele indicar que el diseño de columnas del informe de asistencia cambió: revise el informe antes de confiar en esta sincronización."
      },
      "ghlFields": {
        "checked": "{{n}} asignaciones verificadas",
        "present": "{{n}} presentes",
        "missing": "{{n}} faltan en GoHighLevel",
        "unresolved": "{{n}} nunca se resolvieron",
        "matchKeyBroken": "contact.wstudio_id, el campo que vincula usuarios de WStudio con contactos de GoHighLevel, está {{outcome}}. Hasta que se corrija, una sincronización real no encontraría coincidencias y crearía un contacto duplicado por cada usuario en cada ejecución.",
        "repairHelp": "Los campos que faltan deben crearse o renombrarse en GoHighLevel y luego volver a ejecutar esta prueba. La consola no puede crearlos."
      }
    },
    "syncWindow": {
      "title": "Estado de ventana de sincronización",
      "syncWindow": "ventana de sincronización",
      "inBackfill": "En relleno",
      "steadyState": "Estado estable",
      "progress": "Progreso del relleno",
      "cursor": "Cursor",
      "lastWindow": "Última ventana",
      "never": "—",
      "loadError": "No se pudo cargar el estado de la ventana de sincronización."
    },
    "jobs": {
      "title": "Trabajos de ingesta · este inquilino",
      "tableAriaLabel": "Trabajos de ingesta para este inquilino",
      "loadError": "No se pudo cargar el historial de trabajos."
    },
    "identity": {
      "loadError": "No se pudo cargar la identidad del inquilino.",
      "opsNotProvisioned": "La configuración operativa de este inquilino aún no está disponible — wsr-api aún no lo ha reflejado. Aparecerá en su próxima sincronización.",
      "status": {
        "ACTIVE": "Activo",
        "INACTIVE": "Inactivo",
        "SUSPENDED": "Suspendido"
      }
    },
    "members": {
      "title": "Personal",
      "help": "Quién puede iniciar sesión en el wsr-admin de este inquilino.",
      "tableAriaLabel": "Personal del inquilino",
      "col": {
        "email": "Correo",
        "name": "Nombre",
        "role": "Rol",
        "status": "Estado",
        "actions": "Acciones"
      },
      "role": {
        "OWNER": "Propietario",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Personal",
        "USER": "Usuario",
        "GUEST": "Invitado"
      },
      "status": {
        "ACTIVE": "Activo",
        "INVITED": "Invitado",
        "DISABLED": "Deshabilitado"
      },
      "loadError": "No se pudo cargar el personal.",
      "empty": "Aún no hay personal.",
      "changeRoleLabel": "Rol para {{email}}",
      "changeRoleError": "No se pudo cambiar el rol. Inténtalo de nuevo.",
      "disableLabel": "Habilitado",
      "toggleStatusError": "No se pudo actualizar el estado del personal. Inténtalo de nuevo.",
      "removeButton": "Quitar",
      "removeConfirmTitle": "¿Quitar personal?",
      "removeConfirmBody": "Esto quita a {{email}} del personal de wsr-admin de este inquilino. Su cuenta no se elimina.",
      "removeError": "No se pudo quitar al personal. Inténtalo de nuevo.",
      "lastOwnerProtected": "Esto eliminaría al último propietario del inquilino.",
      "roleChangeCrossesTables": "Este cambio de rol no está permitido para este miembro del personal.",
      "addTitle": "Agregar personal",
      "addEmailLabel": "Correo",
      "addEmailRequired": "El correo es obligatorio.",
      "addRoleLabel": "Rol",
      "addButton": "Agregar",
      "addSuccessMember": "Personal agregado.",
      "addSuccessInvitation": "Invitación enviada.",
      "addErrorAlreadyActive": "Esta persona ya es personal activo.",
      "addErrorAlreadyPending": "Ya hay una invitación pendiente para este correo.",
      "addError": "No se pudo agregar al personal. Inténtalo de nuevo."
    },
    "invitations": {
      "title": "Invitaciones",
      "tableAriaLabel": "Invitaciones del inquilino",
      "col": {
        "email": "Correo",
        "role": "Rol",
        "status": "Estado",
        "created": "Creada",
        "expires": "Expira",
        "actions": "Acciones"
      },
      "statusAll": "Mostrar todas",
      "status": {
        "PENDING": "Pendiente",
        "ACCEPTED": "Aceptada",
        "REVOKED": "Revocada",
        "EXPIRED": "Expirada"
      },
      "loadError": "No se pudieron cargar las invitaciones.",
      "empty": "No hay invitaciones pendientes.",
      "emptyAll": "No hay invitaciones.",
      "resendButton": "Reenviar",
      "resendError": "No se pudo reenviar la invitación. Inténtalo de nuevo.",
      "revokeButton": "Revocar",
      "revokeConfirmTitle": "¿Revocar invitación?",
      "revokeConfirmBody": "Esto revoca la invitación pendiente a {{email}}. Ya no podrá aceptarla.",
      "revokeError": "No se pudo revocar la invitación. Inténtalo de nuevo.",
      "alreadyAccepted": "Esta invitación ya fue aceptada. La lista se ha actualizado.",
      "notFound": "No se encontró esta invitación. La lista se ha actualizado."
    }
  },
  "tenantQueue": {
    "title": "Cola",
    "empty": "Nada en ejecución ni programado."
  },
  "warehouse": {
    "title": "Almacén",
    "members": "Miembros de WStudio",
    "sales": "Ventas",
    "attendance": "Asistencia",
    "products": "Productos",
    "syncedAgo": "sincronizado hace {{duration}}",
    "fullHistory": "historial completo",
    "backTo": "hasta {{date}}"
  },
  "activity": {
    "title": "Actividad",
    "ranAgo": "hace {{duration}}",
    "col": {
      "job": "Trabajo",
      "kind": "Tipo",
      "records": "Registros",
      "ran": "Ejecutado",
      "next": "Siguiente"
    },
    "caughtUp": "Al día",
    "counters": {
      "fetched": "{{n}} obtenidos",
      "landed": "{{n}} cargados",
      "updated": "{{n}} actualizados",
      "unchanged": "{{n}} sin cambios",
      "failed": "{{n}} fallidos",
      "ghlUpdates": "{{n}} actualizaciones de GHL",
      "ghlInserts": "{{n}} inserciones de GHL",
      "ghlFailures": "{{n}} fallos de GHL",
      "ghlContactsRetrieved": "{{n}} contactos GHL recuperados",
      "labelRows": "{{n}} filas de etiquetas",
      "categoryRows": "{{n}} filas de categoría",
      "detailLines": "{{n}} líneas de detalle",
      "duplicatesCollapsed": "{{n}} duplicados agrupados",
      "rowsInSheet": "{{n}} filas en la hoja"
    },
    "kind": {
      "GENESIS": "génesis",
      "BACKFILL": "histórico",
      "LEADING_EDGE": "borde actual",
      "INCREMENTAL": "incremental"
    },
    "next": {
      "in": "en {{duration}}",
      "off": "desactivado"
    }
  },
  "syncHistory": {
    "title": "Historial de sincronización",
    "emptyJobs": "No hay ejecuciones de sincronización en los últimos 14 días.",
    "emptyJournalUserSync": "No hubo cambios por usuario en esta ejecución.",
    "emptyJournalOtherType": "Este tipo de trabajo no tiene diario por fila. El resultado y los recuentos están en el encabezado de la ejecución.",
    "emptyJournalUnknown": "No hay diario por fila para esta ejecución.",
    "jobNotFound": "Esta ejecución ya no se conserva.",
    "backToList": "Volver a la lista",
    "loadError": "No se pudo cargar el historial de sincronización.",
    "journalTitle": "Diario",
    "jobTitle": "Trabajo {{id}}",
    "filters": {
      "statusAria": "Filtrar por estado",
      "allStatuses": "Todos los estados",
      "typeLabel": "Tipo de trabajo",
      "allTypes": "Todos los tipos",
      "severityLabel": "Gravedad",
      "allSeverities": "Todas las gravedades"
    },
    "col": {
      "id": "Id",
      "job": "Trabajo",
      "status": "Estado",
      "kind": "Tipo",
      "finished": "Finalizado",
      "records": "Registros",
      "when": "Cuándo",
      "severity": "Grav.",
      "action": "Acción",
      "entity": "Entidad",
      "summary": "Resumen"
    },
    "action": {
      "CREATED": "CREADO",
      "UPDATED": "ACTUALIZADO",
      "TAGGED": "ETIQUETADO",
      "FAILED": "FALLIDO"
    },
    "entity": {
      "USER": "Usuario",
      "GHL_CONTACT": "Contacto de GoHighLevel"
    },
    "facts": {
      "show": "Mostrar detalles",
      "hide": "Ocultar detalles"
    },
    "prevPage": "Página anterior",
    "nextPage": "Página siguiente",
    "pageIndicator": "Página {{page}} de {{total}}"
  },
  "genesis": {
    "complete": "Completo",
    "loading": "Cargando historial",
    "notStarted": "No iniciado",
    "coveredFrom": "hasta {{date}}",
    "coverageDays": "{{n}} días cubiertos",
    "windowsRemaining": "{{n}} ventanas restantes"
  },
  "readiness": {
    "notConfigured": "WStudio aún no está configurado para este inquilino.",
    "notVerified": "Ejecute las pruebas de simulación de WStudio para verificar esta configuración. Si la configuración cambió recientemente, vuelva a ejecutarlas.",
    "readyToStart": "Verificado y listo. Habilite este inquilino para empezar a cargar su historial.",
    "blockedGlobal": "La ingesta está deshabilitada en toda la plataforma. Habilítela en Inquilinos → Activar la ingesta global.",
    "blockedTenant": "Verificado y listo. Habilite este inquilino para empezar a cargar su historial.",
    "blockedServices": "Verificado y listo, pero estos servicios están desactivados: {{services}}.",
    "genesisSales": "Cargando el historial de ventas. Esto se resuelve solo: no se requiere ninguna acción.",
    "genesisAttendance": "Cargando el historial de asistencia. Esto se resuelve solo: no se requiere ninguna acción.",
    "syncing": "Sincronizando con GoHighLevel. El historial de asistencia más antiguo aún se está cargando, por lo que las señales de interacción todavía no están disponibles: esto es normal."
  },
  "phase": {
    "notConfigured": "Sin configurar",
    "notVerified": "Sin verificar",
    "readyToStart": "Listo para iniciar",
    "genesisSales": "Cargando ventas",
    "genesisAttendance": "Cargando asistencia",
    "syncing": "Sincronizando",
    "complete": "Completo"
  },
  "emailIdentity": {
    "title": "Identidad de correo",
    "fromName": "Nombre del remitente",
    "fromAddress": "Dirección del remitente",
    "supportEmail": "Dirección de soporte",
    "managedElsewhere": "Se configura fuera de esta consola."
  },
  "reset": {
    "title": "Restablecer datos de WStudio",
    "description": "Elimina de forma permanente todo lo que este inquilino descargó de WStudio. No se puede deshacer.",
    "button": "Restablecer datos",
    "blocked": {
      "tenantEnabled": "Deshabilite este inquilino antes de restablecerlo.",
      "jobsInFlight": "Espere a que terminen los trabajos en curso e inténtelo de nuevo."
    },
    "willDelete": "Esto eliminará de forma permanente:",
    "showAllTables": "Mostrar todas las tablas",
    "kept": "Se conservan: el inquilino, su programación de sincronización y sus interruptores, los destinatarios de informes y el historial de auditoría.",
    "ghlNote": "No se toca GoHighLevel. Los contactos, campos personalizados y etiquetas de estos miembros permanecen en GoHighLevel y deben eliminarse allí.",
    "alsoDeleteConfig": "Borrar también la configuración de conexión de WStudio",
    "alsoDeleteConfigHelp": "Deberá volver a introducir el dominio, el token y el Studio ID antes de que este inquilino pueda sincronizar.",
    "confirmLabel": "Escriba {{slug}} para confirmar",
    "confirmButton": "Eliminar permanentemente",
    "successTitle": "Restablecimiento completado",
    "successNextSteps": "Este inquilino ahora no está verificado y no se ejecutará nada. Ejecute las pruebas de simulación y luego habilítelo para volver a cargar el historial.",
    "confirmMismatch": "El nombre del inquilino no coincide.",
    "nothingDeleted": "No se eliminó nada."
  },
  "bootstrap": {
    "error": "No se pudo cargar la configuración de la aplicación.",
    "errorNotRegistered": "Este host no está registrado. Contacte a su administrador.",
    "retry": "Reintentar"
  },
  "errors": {
    "generic": "Algo salió mal. Inténtalo de nuevo.",
    "network": "Error de red. Comprueba tu conexión e inténtalo de nuevo.",
    "codes": {
      "SESSION_EXPIRED": "Tu sesión ha expirado. Inicia sesión de nuevo.",
      "NETWORK_ERROR": "Error de red. Comprueba tu conexión e inténtalo de nuevo.",
      "UNKNOWN": "Algo salió mal."
    }
  }
}
